<template>
  <span>{{ tweeningValue }}</span>
</template>

<script>
import TWEEN from '@tweenjs/tween.js';

export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    tweenDuration: {
      type: Number,
      default: 2000
    },
    append: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tweeningValue: 0
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.tween(oldValue, newValue)
    }
  },
  mounted() {
    this.tween(0, this.value, this.append)
  },
  methods: {
    tween(start, end, append) {
      let frameHandler

      // Handles updating the tween on each frame.
      const animate = function(currentTime) {
        TWEEN.update(currentTime)
        frameHandler = requestAnimationFrame(animate)
      }

      const myTween = new TWEEN.Tween({ tweeningValue: start })
        .to({ tweeningValue: end }, this.tweenDuration)
        .onUpdate(() => {
          this.tweeningValue = myTween._object.tweeningValue.toFixed(0)

          if (this.append) {
            this.tweeningValue += this.append;
          }
        })
        .onComplete(() => {
          cancelAnimationFrame(frameHandler)
        })
        .start()

      frameHandler = requestAnimationFrame(animate)
    }
  }
}
</script>

<style scoped>
</style>
